import React from 'react';
import '../../../../Stylesheets/Dashboard/SmartSuggestions.css';

const SmartSuggestions = () => {
  // Static example data — make dynamic based on actual conditions later
  const suggestions = [
    {
      message: 'Skyline Tower has not added daily logs from 2 days',
      actionText: 'Add Log',
    },
    {
      message: 'Skyline Tower has not added daily logs from 2 days',
      actionText: 'Add Log',
    },
    {
      message: 'Skyline Tower has not added daily logs from 2 days',
      actionText: 'Mark Attendance',
    },
  ];

  return (
    <div className="suggestion-wrapper">
      <h3 className="overview-section-title">Smart Suggestion</h3>
      <div className="suggestion-list">
        {suggestions.map((item, index) => (
          <div className="suggestion-card" key={index}>
            <p className="suggestion-text">{item.message}</p>
            <button className="suggestion-acthghghion">{item.actionText}</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SmartSuggestions;
